import { render, staticRenderFns } from "./RemindPasswordForm.vue?vue&type=template&id=c168b914&scoped=true&"
import script from "./RemindPasswordForm.vue?vue&type=script&lang=ts&"
export * from "./RemindPasswordForm.vue?vue&type=script&lang=ts&"
import style0 from "./RemindPasswordForm.vue?vue&type=style&index=0&id=c168b914&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c168b914",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})
